import { Link } from "react-router-dom"
import { isArabic } from "../../../../isArabic"
import { PENDING, ACCEPED, REJECTED } from "../../JobsManager/JobStatus"
import classes from './EmployerJobCard.module.css'

export interface IEmployerJobCardProps {
    title: string,
    status: string,
    applications: string | number,
    id: string | number
}


const EmployerJobCard: React.FC<IEmployerJobCardProps> = (props)=>{


    let contStyle
    switch(props.status){
        case PENDING:
          contStyle = [classes.linkContainer, classes.colY].join(' ')
          break;
        case ACCEPED:
          contStyle = [classes.linkContainer, classes.colG].join(' ')
          break;
        case REJECTED:
            contStyle = [classes.linkContainer, classes.colR].join(' ')
          break;
        default:
            contStyle = [classes.linkContainer, classes.colD].join(' ')
    }

    
    /* const contStyle = props.status === PENDING ? 
    [classes.linkContainer, classes.colY].join(' ') : 
    props.status === ACCEPED ? 
    [classes.linkContainer, classes.colG].join(' ') : 
    [classes.linkContainer, classes.colD].join(' ') */

    return(
        <Link 
            to={`job/${props.id}`}
            className={`row ${contStyle} mx-0`} 
        >
            <div className='col-3'style={{boxSizing: 'border-box'}}>
                <p className={classes.pValue} style={{fontWeight: 'bold'}}>{props.applications}</p>
            </div>
            <div className='col-3'style={{boxSizing: 'border-box'}}>
                <p className={classes.pValue}>{props.status}</p>
            </div>
            <div className={'col-6'} style={{boxSizing: 'border-box'}}>
                <p className={isArabic(props.title)  ? 
                    [classes.arabic, classes.pValue, classes.rightP].join(' ') :  
                    [classes.pValue, classes.rightP].join(' ')}
                >
                    {props.title}
                </p>
            </div>
         </Link>
    )
}

export default EmployerJobCard